import { createAction, props } from '@ngrx/store';
import { ConfirmationDialogSettings } from 'src/app/shared/models/confirmation-dialog-settings.model';

export const openConfirmationDialog = createAction(
    '[OPEN CONFIRMATION DIALOG] Open a confirmation dialog',
    props<{ settings: ConfirmationDialogSettings }>()
);
export const openConfirmationDialogConfirmed = createAction(
    '[OPEN CONFIRMATION DIALOG] Open Confirmation Dialog Confirmed',
    props<{ result: boolean; data?: unknown }>()
);
export const openConfirmationDialogCancelled = createAction(
    '[OPEN CONFIRMATION DIALOG] Open Confirmation Dialog Cancelled',
    props<{ canceled: boolean }>()
);

export const resetDialogState = createAction('[RESET CONFIRMATION DIALOG] Reset Confirmation dialog');
